import Cookies from 'js-cookie';
import { COOKIE_REFRESH_ID, COOKIE_REFRESH_TOKEN } from '../../constants';

// ---------- cookie helpers ------------

const setCookie = (key, value, domain) => {
  Cookies.set(key, value, {
    expires: 730,
    domain,
    path: '/',
  });
};

const resetCookies = domain => {
  setCookie(COOKIE_REFRESH_TOKEN, '', domain);
  setCookie(COOKIE_REFRESH_ID, '', domain);
};

// ---------- auth service methods ------------

export const getAuthData = () => {
  const authToken = localStorage.getItem('authToken');
  const refreshToken = Cookies.get(COOKIE_REFRESH_TOKEN);
  const refreshId = Cookies.get(COOKIE_REFRESH_ID);
  const isLoggedIn = localStorage.getItem('isLoggedIn');

  return {
    authToken,
    refreshToken,
    refreshId,
    isLoggedIn: isLoggedIn && isLoggedIn === 'Y',
  };
};

export const resetAuthData = domain => {
  localStorage.clear();
  resetCookies(domain);
  localStorage.setItem('isLoggedIn', 'N');
};

export const setAuthData = ({ authToken, refreshToken, refreshId, domain }) => {
  localStorage.setItem('authToken', authToken);

  // set same in cookies
  setCookie(COOKIE_REFRESH_TOKEN, refreshToken, domain);
  setCookie(COOKIE_REFRESH_ID, refreshId, domain);
};

export const setLoggedInFlag = (domain, booleanValue) => {
  if (!booleanValue) {
    resetCookies(domain);
  }
  localStorage.setItem('isLoggedIn', booleanValue ? 'Y' : 'N');
};

export const updateAuthTokenOnly = authToken => {
  localStorage.setItem('authToken', authToken);
};

export const getAuthorizationHeaderValue = () => {
  const authToken = localStorage.getItem('authToken');
  return authToken ? `Bearer ${authToken}` : '';
};
